import {React, useState, useEffect} from 'react'
import './App.css';
import { FormControl, Select, MenuItem, Card, CardContent } from '@material-ui/core';
import InfoBox from './InfoBox'
import Map from './Map'
import Table from './Table'
import {sortData, prettyPrintStat } from './util'
import LineGraph from './LineGraph'
import "leaflet/dist/leaflet.css"


function App() {
  // const position = [51.505, -0.09]

  const [countries, setCountries] = useState([])
  const [country, setCountry] = useState('worldwide')
  const [stats, setStats] = useState({})
  const [tableData, setTableData] = useState([])
  const [mapCenter, setMapCenter] = useState([51.505, -0.09])
  const [mapZoom, setMapZoom] = useState(3)
  const [mapCountries, setMapCountries] = useState([])
  const [caseType, setCaseType] = useState("cases")



  /** INFOBOX DATA */
  useEffect(async () => {
    await fetch('https://disease.sh/v3/covid-19/all')
    .then((response) => response.json())
    .then(data => {
      setStats(data)
    })
  }, [])


  /**Table on the app__Right container */
  /** Dropdown in header */
  
  useEffect(() => {
    const getCountriesData = async () => {
      await fetch("https://disease.sh/v3/covid-19/countries")
      .then((response) => response.json())
      .then((data) => {
        const countries = data.map((country) => ({
          name:country.country, // United State, United Kingdom
          value:country.countryInfo.iso2 // UK,USA, FR
        }));
        const sortedData = sortData(data, caseType)
    
        setTableData(sortedData)
        setCountries(countries)
        setMapCountries(data)
      })
    }
    getCountriesData(countries)
  }, [])

  /** Set mapCenter */
  const onCountryChange = async (e) => {    
      const countryCode = e.target.value
      const url = (countryCode === 'worldwide')?'https://disease.sh/v3/covid-19/all':`https://disease.sh/v3/covid-19/countries/${countryCode}`
      await fetch(url).then((response) => response.json())
      .then(data => {
        setStats(data)
        setCountry(countryCode)
        setMapCenter([data.countryInfo.lat, data.countryInfo.long])
        setMapZoom(4)
        
      })
      // console.log(stats)
     
    
  }

  return (
    
    <div className="app">
      <div className="app__left">
        <div className="app__header">
        <h1>COVID-19 TRACKER</h1>
        <div className="app__dropdown">      
          <FormControl>
            <Select variant="outlined" value={country} onChange={onCountryChange}>
            <MenuItem value="worldwide"><em>worldwide</em></MenuItem>
              {
                countries.map(({name,value})=>
                  (<MenuItem value={value} key={value}>{name}</MenuItem>)
                )
              }
            </Select>
          </FormControl>
        </div>
        

        </div>

        <div className="app__stats">
        <InfoBox 
          active={ caseType === "cases" }
          onClick = { e =>  setCaseType('cases')}
          title="Coronavirus Cases" 
          total={prettyPrintStat(stats.todayCases)} 
          cases={prettyPrintStat(stats[caseType])} 
        />
          <InfoBox 
            active={ caseType === "recovered" }
            isGreen={caseType === "recovered"}
            onClick = { e =>  setCaseType('recovered')}
            title="Recovered" 
            total={prettyPrintStat(stats.todayRecovered)} 
            cases={prettyPrintStat(stats.recovered)}
          />
         
          <InfoBox 
            active={ caseType === "deaths" }
            onClick = { e =>  setCaseType('deaths')}
            title="Deaths" 
            total={prettyPrintStat(stats.todayDeaths)} 
            cases={prettyPrintStat(stats.deaths)} 
          />
        
        </div>
        <Map center={mapCenter} zoom={mapZoom} countries={mapCountries} caseType={caseType} />
      </div>
      <Card className="app__right">
          <CardContent>
          <h3>Live cases by country </h3>
          <Table countries={tableData} caseType={caseType} />
          <h3 style={{marginTop:"20px"}}>worldwide new {caseType}</h3>
          <LineGraph caseType={caseType}/>
          </CardContent>
          
      </Card>
      
    </div>
  );
}

export default App;
